module.exports = __webpack_public_path__ + "img/7406e84.jpg";